import { Pipe, PipeTransform, Injectable } from '@angular/core';

import * as dataCore from "./datacore";

@Pipe({
    name: "crewFilterBy"
})
@Injectable()
export class FilterByPipe implements PipeTransform {
    transform(items: any[], filter: string, propertyName: string): any[] {
        return dataCore.filterBy(items, filter, propertyName);
    }
}


// WEBPACK FOOTER //
// ./node_modules/angular2-template-loader!./node_modules/@angularclass/hmr-loader!./node_modules/tslint-loader!./client/app/core/filter-by.pipe.ts